import React from 'react';
import HeaderOne from '../../common/header/HeaderOne';
import BreadcrumbOne from '../../common/breadcrumb/BreadcrumbOne';
import BlogRightSidebarTwoGridSectionOne from '../../components/blog-components/BlogRightSidebarTwoGridSectionOne';
import FooterOne from '../../common/footer/FooterOne';

const BlogRightSidebarTwoGridOne = () => {
    return (
        <>
        <HeaderOne />

        <BreadcrumbOne 
            title="Blog Right Sidebar Two Grid 1"
            rootUrl="/"
            parentUrl="Home"
            currentUrl="Blog Right Sidebar Two Grid 1"
        />
        
        <BlogRightSidebarTwoGridSectionOne />
        
        <FooterOne />
        </>
    )
}
    
export default BlogRightSidebarTwoGridOne;